import React, { useState, useEffect, useMemo } from "react";
import io from "socket.io-client";
import {
    Tabs,
    TabsList,
    TabsTrigger,
    TabsContent,
} from "./rydercup/components/ui/Tabs";
import { TournamentHeader } from "./rydercup/components/TournamentHeader";
import { SessionView } from "./rydercup/components/SessionView";
import "../styles/ryder-cup-view.css";

function TournamentScoreboard({ data }) {
    const [stateData, setStateData] = useState(
        data || { competition: {}, teams: {}, rounds: {} }
    );

    useEffect(() => {
        const socket = io("https://ws.nextcaddy.com:29920");
        socket.on("new message", (response) => {
            if (
                response &&
                stateData.competition &&
                response.message.competicion === stateData.competition.id &&
                response.message.tipo === "ryder_cup_livescoring"
            ) {
                setStateData(response.message.data);
            }
        });
        return () => socket.disconnect();
    }, [stateData]);

    const teams = stateData.teams || {};
    const rounds = stateData.rounds || {};
    const teamIds = Object.keys(teams);
    const [first, second] = teamIds;
    const teamColors = {
        [first]: teams[first]?.color,
        [second]: teams[second]?.color,
    };

    const sessions = useMemo(() => {
        const filtered = Object.entries(rounds)
            .filter(([, r]) => r.matches && Object.keys(r.matches).length > 0)
            .sort(([, a], [, b]) => a.order - b.order);

        return filtered.map(([id, round], idx) => ({
            id,
            name: `Round ${idx + 1}`,
            date: new Date(round.initial_date.date).toLocaleDateString("es-ES", {
                day: "2-digit",
                month: "short",
                year: "numeric",
            }),
            matches: Object.entries(round.matches).map(([mid, m]) => ({
                id: mid,
                ...m,
            })),
        }));
    }, [rounds]);

    const [activeTab, setActiveTab] = useState(sessions[0]?.id || "");

    return (
        <div
            className={`
        flex flex-col
        w-full mx-auto px-2 py-2
        overflow-x-hidden
        sm:h-screen sm:overflow-hidden
        md:h-screen md:overflow-hidden
        lg:flex-row lg:space-x-2 lg:h-screen
      `}
        >
            <aside className="mb-2 lg:mb-0 lg:w-1/4">
                <TournamentHeader
                    competition={stateData.competition}
                    teams={teams}
                />
            </aside>

            <div className="flex-1 flex flex-col overflow-hidden">
                <main className="flex-1 bg-slate-100 overflow-hidden rounded-lg p-2 shadow-md">
                    {sessions.length > 1 ? (
                        <Tabs defaultValue={activeTab} onValueChange={setActiveTab}>
                            <TabsList className="mb-4 grid grid-cols-2 gap-2">
                                {sessions.map((s) => (
                                    <TabsTrigger
                                        key={s.id}
                                        value={s.id}
                                        className="text-xs sm:text-sm xl:text-xl 2xl:text-3xl"
                                    >
                                        {s.name}
                                    </TabsTrigger>
                                ))}
                            </TabsList>

                            {sessions.map((s) => (
                                <TabsContent key={s.id} value={s.id}>
                                    <SessionView
                                        session={s}
                                        teamColors={teamColors}
                                        teams={teams}
                                    />
                                </TabsContent>
                            ))}
                        </Tabs>
                    ) : (
                        sessions[0] && (
                            <SessionView
                                session={sessions[0]}
                                teamColors={teamColors}
                                teams={teams}
                                showHeader={false}
                            />
                        )
                    )}
                </main>
            </div>
        </div>
    );
}

export default TournamentScoreboard;
